import React from 'react';
import { Container } from 'styles/Styles.styled';
import { H1NewUI } from 'styles/v2/Styles.styled';

const ForbiddenPage: React.FC = () => {
  return (
    <Container>
      <div>
        <H1NewUI>403 Access denied</H1NewUI>
        <p>You don't have access to view this page.</p>
      </div>
    </Container>
  );
};

export default ForbiddenPage;
